import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import styles from "./TrimesterTabs.module.scss";
import {
  BLACK,
  GREEN_LIGHT,
  WHITE,
} from "../../utility/constants/common-constants";
import { useTranslation } from "react-i18next";

interface Props {
  value: string | number;
  toggleButtonData: any[];
  isLearningContent?: boolean;
  onChange: (val: string | number) => void;
}

const TrimesterTabs = ({
  value,
  toggleButtonData,
  isLearningContent = false,
  onChange,
}: Props) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      value={String(value)}
      exclusive
      onChange={(e, newVal) => {
        if (newVal === null) return;
        const parsedVal = isNaN(Number(newVal)) ? newVal : Number(newVal);
        onChange(parsedVal);
      }}
      className={styles.toggleGroup}
      sx={{
        mb: { xs: !isLearningContent ? 7 : 0, md: !isLearningContent ? 4 : 0 },
        ".MuiToggleButton-root": {
          textTransform: "none",
          borderRadius: isLearningContent ? "24px" : "8px",
          backgroundColor: isLearningContent ? "#f2f0ec" : GREEN_LIGHT,
          padding: "0.5rem 1.5rem",
          border: `1px solid ${BLACK}`,
          color: BLACK,
          "&:hover": {
            backgroundColor: WHITE,
            borderRadius: isLearningContent ? "24px" : "8px",
          },
          "&.Mui-selected": {
            backgroundColor: WHITE,
            borderRadius: isLearningContent ? "24px" : "8px",
            "&:hover": {
              backgroundColor: WHITE,
              borderRadius: isLearningContent ? "24px" : "8px",
            },
            span: {
              fontWeight: 600,
            },
          },
        },
        ".MuiToggleButtonGroup-firstButton": {
          borderRadius: isLearningContent ? "24px" : "8px",
        },
        ".MuiToggleButtonGroup-middleButton, .MuiToggleButtonGroup-lastButton":
          {
            borderRadius: isLearningContent ? "24px" : "8px",
            border: `1px solid ${BLACK}`,
          },
      }}
    >
      {toggleButtonData.map(({ labelKey, value: optionValue }) => (
        <ToggleButton
          key={labelKey}
          value={String(optionValue)}
          className={styles.tabButton}
          disableRipple
          disableFocusRipple
        >
          <Typography variant="body1" component="span" noWrap>
            {isLearningContent ? labelKey : t(labelKey)}
          </Typography>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default TrimesterTabs;
